<div class="tmp-section-item-wrapper">
    <div class="tmp-section-header" (click)="toggleExpand()">
        <span multilang class="tmp-section-title">{{ title }}</span>
        <mat-icon class="arrow-icon" [class.expanded]="expanded">
            {{ expanded ? 'expand_less' : 'expand_more' }}
        </mat-icon>
    </div>

    <div class="tmp-section-body" style="max-height: 217px;overflow-y: auto;" *ngIf="expanded">
        @if (!isCheckBox) {
        <div class="tmp-section-body tmp-flexy">
            <ng-container *ngFor="let item of list">
                <button class="tmp-f-btn" [class.tmp-f-btn-selected]="item.selected" [matTooltip]="item?.description"
                    (click)="selectItem(item)" matRipple>
                    {{ item.name }}
                </button>
            </ng-container>
        </div>
        } @else {
        <div class="tour-wrapper">
            @for (item of list | slice:0:slicenbr; track $index) {
            <button class="tour-item-wrapper" (click)="selectItem(item)" [matTooltip]="item?.description" matRipple>
                <mat-icon class="tour-item-icon" [style.color]="item.selected ? '#7ed0f5' : ''">
                    {{ item.selected ? 'radio_button_checked' : 'radio_button_unchecked' }}
                </mat-icon>
                <span multilang class="tour-item-name">{{ item.name }}</span>
            </button>
            }

            @if (list?.length > 5) {
            @if (slicenbr < list.length) { <button class="showallbtn" (click)="showMore(list.length)" matRipple>
                <span multilang>alle {{ list.length }} anzeigen</span>
                </button>
                } @else {
                <button class="showallbtn" (click)="showMore(5)" matRipple>
                    <span multilang>weniger anzeigen</span>
                </button>
                }
                }
        </div>

        }
    </div>
    <mat-divider style="border: 1px solid #f3f3f3;margin-top: 12px;"></mat-divider>
</div>